import {create} from "apisauce";
import {getCookie, setCookie} from "../../utils/cookies";
import jwtDecode from "jwt-decode";

const apiClient = create({
    baseURL: process.env.REACT_APP_CALCULATION_URL,
    headers: {
        "Access-Control-Allow-Origin": "*",
        "Content-Type": "application/json",
    },
});

apiClient.addAsyncRequestTransform(async (request) => {

    const authToken = getCookie("ycon_auth0_token")
    if (jwtDecode(authToken).exp < Math.round(Date.now() / 1000)) {
        setCookie("ycon_auth0_token", null)
        window.location.reload()
    }
    if (!authToken) return;
    if (!request.headers["authorization"]) request.headers["authorization"] = "Bearer " + authToken;

});

export default apiClient;
